export { default } from "./ProductImagesTrio";
